"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimeInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
var CJFormContext_1 = require("../CJFormContext");
var util_1 = require("../util");
var R = __importStar(require("../../../utils/ramda"));
var useRandomGuid_1 = require("../../../hooks/useRandomGuid");
var CJField_1 = require("./CJField");
var DateInput_1 = require("../../../components/DateInput");
var DateTimeInput = function (props) {
  var _a = (0, react_1.useContext)(CJFormContext_1.CJFormContext),
    control = _a.control,
    formState = _a.formState,
    setError = _a.setError;
  var _b = __read((0, util_1.extractRegister)(props), 2),
    _c = _b[0],
    registerProps = _b[1],
    name = _c.name,
    _d = _c.onBlur,
    onBlur = _d === void 0 ? R.N : _d,
    _e = _c.clearable,
    clearable = _e === void 0 ? true : _e,
    _f = _c.invalidMessage,
    invalidDateMessage = _f === void 0 ? "Invalid date" : _f,
    dateFormat = _c.dateFormat,
    _g = _c.readOnly,
    readOnly = _g === void 0 ? false : _g,
    transform = _c.transform,
    transformClear = _c.transformClear,
    restProps = __rest(_c, ["name", "onBlur", "clearable", "invalidMessage", "dateFormat", "readOnly", "transform", "transformClear"]);
  var _h = (0, react_1.useContext)(CJField_1.CJFieldContext),
    fieldName = _h.fieldName,
    fieldGuid = _h.fieldGuid;
  return (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, {
    name: name,
    control: control,
    rules: registerProps,
    render: function (_a) {
      var _b;
      var field = _a.field;
      var config = (0, DateInput_1.useDateInput)({
        startDate: field.value,
        transform: transform,
        transformClear: transformClear,
        onChange: function (v) {
          field.onChange(v);
          field.onBlur();
        }
      });
      var _c = __read((0, useRandomGuid_1.useRandomGuid)(), 2),
        guid = _c[0],
        refresh = _c[1];
      (0, react_1.useEffect)(function () {
        // setTimeout to lower the chance of flashing an error for
        // a split second when there isn't actually a problem
        setTimeout(function () {
          if (!config.valid && config.text) {
            setError(name, {
              type: "date",
              message: invalidDateMessage
            });
          }
        }, 100);
      }, [config.valid, config.text, guid]);
      return (0, jsx_runtime_1.jsx)(DateInput_1.DateInput, __assign({
        id: fieldName === name ? fieldGuid : undefined
      }, config, restProps, {
        date: field.value,
        dateFormat: dateFormat,
        disabled: registerProps.disabled,
        readOnly: readOnly,
        showIcon: true,
        popoverProps: R.mergeDeepRight({
          wrapperProps: {
            style: {
              width: "unset"
            }
          }
        }, (_b = restProps === null || restProps === void 0 ? void 0 : restProps.popoverProps) !== null && _b !== void 0 ? _b : {}),
        error: !!formState.errors[name],
        onBlur: function (e) {
          field.onBlur();
          onBlur(e);
          refresh();
        },
        clearable: clearable && !readOnly
      }));
    }
  });
};
exports.DateTimeInput = DateTimeInput;